import { v4 as uuid } from 'uuid';
var regExpAbsoluteUrl = /:\/\//i;
var regExpLeadingSlash = /^\//i;
export function isOptions(x) {
  return x != null && Object(x) === x && x.success == null;
}
export function isActionCreators(creators, x) {
  return x && typeof x === 'object' && creators.reduce(function (found, creator) {
    return found || typeof x[creator] === 'function';
  }, false);
}
export var isDependencies = function isDependencies(x) {
  return x && x instanceof Array;
};
export var generateQueryId = function generateQueryId(name, resolver) {
  return name + "-" + resolver + "-" + uuid();
};
export var isAbsoluteUrl = function isAbsoluteUrl(value) {
  return regExpAbsoluteUrl.test(value);
};
export var isLeadingSlash = function isLeadingSlash(value) {
  return regExpLeadingSlash.test(value);
};
export var isString = function isString(value) {
  return value != null && value.constructor === String;
};
export var isNonString = function isNonString(value) {
  return !isString(value);
};
export var assertString = function assertString(value, name) {
  if (!isString(value)) {
    // eslint-disable-next-line
    console.error(value);
    throw new Error(name + " must be a string");
  }
};
export var nonEmptyString = function nonEmptyString(value, name) {
  assertString(value, name);

  if (value === '') {
    // eslint-disable-next-line
    console.error(value);
    throw new Error(name + " must be a non-empty string");
  }
};
export var leadingSlash = function leadingSlash(value, name) {
  if (!isLeadingSlash(value)) {
    // eslint-disable-next-line
    console.error(value);
    throw new Error(name + " must have leading \"/\"");
  }
};
export var arrayOfString = function arrayOfString(value, name) {
  if (!Array.isArray(value) || value.find(isNonString)) {
    // eslint-disable-next-line
    console.error(value);
    throw new Error(name + " must be an Array<String>");
  }
};
//# sourceMappingURL=helpers.js.map